module.exports = __webpack_public_path__ + "static/media/co-founder-4.7cebdf01.jpg";